import { createPortal } from "react-dom";
import { usePluginConfig } from "../contexts/pluginContext";
import PluginFrame from "../utils/PluginFrame";

const Head = ({ children }) => {
	const frameConfig = usePluginConfig().frameConfig;
	const pluginFrame = new PluginFrame(frameConfig);
	return createPortal(children, pluginFrame.shadowRoot);
};
export default Head;
